import { Link } from "react-router-dom";
import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div className="App">
      <header className="App-section">
        <h1>Oops!</h1>
        <p>Sorry, an unexpected error has occurred. 404 or 401 unauth</p>
        <p>
          <i>{error.statusText || error.message}</i>
        </p>
        <Link to="/">Sign In</Link>
      </header>
    </div>
  );
}
